import { Input } from 'antd'
import { useEffect, useState } from 'react'

{ TextArea } = Input

EditableInput = ({ initialValue, save, inputValidator=((e)-> e.target.value), props... }) ->

  [loading, setLoading] = useState(false)
  [value, setValue] = useState(initialValue)

  useEffect(->
    setValue(initialValue)
  , [initialValue])

  <TextArea
    allowClear
    rows={3}
    value={value}
    disabled={loading}
    {props...}
  />

export default EditableInput
